import { formatMetric } from '../panelConfig';

const div = (a, b) => (a != null && b ? a / b : null);

const COLUMNS = [
  { key: 'date', label: 'Fecha', format: 'date', align: 'left' },
  { key: 'revenue', label: 'Revenue', format: 'currency' },
  { key: 'target', label: 'Target', format: 'currency' },
  { key: 'pct_obj', label: '% Obj.', format: 'percent' },
  { key: 'orders', label: 'Órdenes', format: 'number' },
  { key: 'ticket', label: 'Ticket', format: 'currency' },
  { key: 'sessions', label: 'Sesiones', format: 'number' },
  { key: 'cr', label: 'CR %', format: 'percent' },
  { key: 'spend', label: 'Spend', format: 'currency' },
  { key: 'spend_google', label: 'Google', format: 'currency' },
  { key: 'spend_meta', label: 'Meta', format: 'currency' },
  { key: 'roas', label: 'ROAS', format: 'ratio' },
  { key: 'pct_mkt', label: '% mkt', format: 'percent' },
];

function toRow(d) {
  return {
    date: d.date,
    revenue: d.revenue,
    target: d.revenue_goal,
    pct_obj: div(d.revenue, d.revenue_goal),
    orders: d.orders,
    ticket: div(d.revenue, d.orders),
    sessions: d.sessions,
    cr: div(d.orders, d.sessions),
    spend: d.spend,
    spend_google: d.spend_google,
    spend_meta: d.spend_meta,
    roas: div(d.revenue, d.spend),
    pct_mkt: div(d.spend, d.revenue),
  };
}

/** Desglose diario del período (día más reciente primero). */
export default function DailyBreakdownTable({ daily }) {
  const rows = daily.map(toRow).reverse();
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-gray-700">Detalle diario</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
              {COLUMNS.map((c) => (
                <th key={c.key} className={`py-2 pr-3 font-medium ${c.align === 'left' ? 'text-left' : 'text-right'}`}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.date} className="border-b border-gray-100 last:border-0">
                {COLUMNS.map((c) => (
                  <td
                    key={c.key}
                    className={`py-2 pr-3 ${c.align === 'left' ? 'text-left font-medium text-gray-900' : 'text-right text-gray-700'}`}
                  >
                    {c.format === 'date' ? r[c.key] : formatMetric(r[c.key], c.format)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
